export const OVERALL_REQUEST = 'OVERALL_REQUEST';
export const OVERALL_SUCCESS = 'OVERALL_SUCCESS';
export const OVERALL_FAIL = 'OVERALL_FAIL';

export const GET_OVERALL_MESSAGE_REQUEST = 'GET_OVERALL_MESSAGE_REQUEST';
export const GET_OVERALL_MESSAGE_SUCCESS = 'GET_OVERALL_MESSAGE_SUCCESS';
export const GET_OVERALL_MESSAGE_FAIL = 'GET_OVERALL_MESSAGE_FAIL';
